export enum FlagStatus {
	NONE = 'NONE',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	LOADING = 'LOADING',
}
